<template>
  <v-dialog persistent max-width="600px" scrollable v-model="value">
    <v-card>
      <v-card-title class="headline">Укажите способ авторизации:</v-card-title>
      <v-card-text>
        <v-divider></v-divider>

        <div v-if="isError" class="container error-alert mt-4">
          <v-alert dense outlined type="error">
            <div>Не удалось произвести авторизацию, попробуйте еще раз</div>
          </v-alert>
        </div>

        <v-radio-group v-model="role" column v-if="roles && roles.length > 0">
          <v-radio
            v-for="(item, index) in roles"
            :key="index"
            :label="`${item.label}`"
            :value="item"
          ></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="choiceRole()"
          :disabled="!role"
          :loading="loading"
        >
          Выбрать
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { AuthModule } from '@/store/modules/auth';
import { RoleTypeAuth } from '@/utils/dictionaries';

export default {
  name: 'SelectAuthRole',
  props: ['value'],
  data() {
    return {
      role: null,
      isError: false,
      loading: false,
    };
  },
  computed: {
    roles() {
      const arr = AuthModule.user?.roleDetails || [];
      return arr && arr.length > 0
        ? [
            {
              label: 'Физ.лицо',
              oid: null,
              type: 'PERSON',
            },
            ...arr.map((item) => ({
              ...item,
              label: `Представитель организации ${item.fullName}`,
            })),
          ]
        : [];
    },
  },
  methods: {
    async choiceRole() {
      this.isError = false;
      this.loading = true;

      const oid = this.role.oid;
      const type = RoleTypeAuth[this.role.type];

      const data = await AuthModule.selectRole({ type, oid });
      if (data) {
        AuthModule.SET_SHOW_DIALOG_ROLE(false);
				await AuthModule.getResource()
      } else {
        this.isError = true;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
